module.exports = __webpack_public_path__ + "img/slack.8cfef028.png";